import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ListChildComponentProps } from 'react-window';

import { BookingInfo } from 'src/api/bookingsView';
import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';
import { List } from 'src/components/List/List';
import { offset } from 'src/components/List/consts';
import { getIsDesktop } from 'src/store/agent/selectors';
import { getBookingsState } from 'src/store/bookings/selectors';
import { BookingsPageMode } from 'src/store/bookings/types';

import { BookingCard } from './BookingCard/BookingCard';
import { desktopBookingCardHeight } from './BookingCard/DesktopBookingCard/consts';
import {
  actualDeskMobileBookingCardHeight,
  historicalDeskMobileBookingCardHeight,
  actualMobileBookingCardHeight,
  historicalMobileBookingCardHeight,
} from './BookingCard/MobileBookingCard/consts';
import { useMyBookings } from './MyBookingsProvider';

const Item: FC<ListChildComponentProps<BookingInfo[]>> = ({
  index,
  style,
  data,
}) => {
  const item = data[index] as BookingInfo | undefined;

  return (
    <div style={style} data-testid='listItem'>
      {item ? <BookingCard booking={item} /> : null}
    </div>
  );
};

export const MyBookingsList: FC = () => {
  const isDesktop = useSelector(getIsDesktop);
  const { loadMore, unbookDialog } = useMyBookings();

  const { rows, loading, bookingObjectType, mode } =
    useSelector(getBookingsState);

  const bookingCardHeight = useMemo(() => {
    if (isDesktop) return desktopBookingCardHeight;

    if (bookingObjectType === BookingObjectType.Desk)
      return mode === BookingsPageMode.Actual
        ? actualDeskMobileBookingCardHeight
        : historicalDeskMobileBookingCardHeight;

    return mode === BookingsPageMode.Actual
      ? actualMobileBookingCardHeight
      : historicalMobileBookingCardHeight;
  }, [bookingObjectType, isDesktop, mode]);

  return (
    <>
      <List
        rows={rows}
        loadMore={loadMore}
        itemSize={bookingCardHeight + offset}
        Item={Item}
        noResults='Бронирования не найдены'
        isLoading={loading}
        loading='Загрузка бронирований'
      />

      {unbookDialog}
    </>
  );
};
